import { render, staticRenderFns } from "./form-mobile-box.vue?vue&type=template&id=8a5d37c8&scoped=true&"
var script = {}
import style0 from "./form-mobile-box.vue?vue&type=style&index=0&id=8a5d37c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5d37c8",
  null
  
)

export default component.exports